import { render, staticRenderFns } from "./order-save-alipay.vue?vue&type=template&id=e5229bb2&scoped=true&"
import script from "./order-save-alipay.vue?vue&type=script&lang=js&"
export * from "./order-save-alipay.vue?vue&type=script&lang=js&"
import style0 from "./order-save-alipay.vue?vue&type=style&index=0&id=e5229bb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5229bb2",
  null
  
)

export default component.exports